import React from 'react'
import { useTranslation } from 'react-i18next'
import { hasText } from 'shared/lib/common-util'
import { PREVIOUS_DOCUMENT_TYPE_CODE_PREFIX, removePrefix } from 'shared/ncts/common/classifier-util'
import TransitPreviewDocumentSection from './TransitPreviewDocumentSection'
import TransitPreviewField from './TransitPreviewField'
import { PreviousDocument } from '../../document/models/types'

interface TransitPreviewPreviousDocumentsProps {
  previousDocuments: PreviousDocument[]
}

function TransitPreviewPreviousDocuments({
  previousDocuments,
}: TransitPreviewPreviousDocumentsProps) {
  const { t } = useTranslation()

  if (!previousDocuments.length) return null

  return (
    <div className="card p-2">
      <h5 className="text-secondary mb-2">
        {
          t('declaration.p5.previousDocuments')
        }
      </h5>
      {
        previousDocuments.map((document) => (
          <TransitPreviewDocumentSection
            key={document.id}
            document={document}
            documentTypePrefix={PREVIOUS_DOCUMENT_TYPE_CODE_PREFIX}
          >
            <div className="col-12">
              <TransitPreviewField
                label={t('declaration.p5.supportingDocumentType')}
                value={removePrefix(document.documentType, PREVIOUS_DOCUMENT_TYPE_CODE_PREFIX) ?? ''}
              />
              <TransitPreviewField
                label={t('declaration.p5.previousDocumentReferenceNumber')}
                value={document.referenceNumber ?? ''}
              />
              <TransitPreviewField
                label={t('declaration.p5.complementOfInformation')}
                value={document.complementOfInformation ?? ''}
              />
              {
                (hasText(document.transportDocumentReferenceNumber)
                    && (removePrefix(document.documentType, PREVIOUS_DOCUMENT_TYPE_CODE_PREFIX) === 'N355'
                      || removePrefix(document.documentType, PREVIOUS_DOCUMENT_TYPE_CODE_PREFIX) === 'N337'
                      || removePrefix(document.documentType, PREVIOUS_DOCUMENT_TYPE_CODE_PREFIX) === 'N785'
                    )
                ) && (
                  <TransitPreviewField
                    label={t('declaration.p5.transportDocumentReferenceNumber')}
                    value={document.transportDocumentReferenceNumber ?? ''}
                  />
                )
              }
            </div>
          </TransitPreviewDocumentSection>
        ))
      }
    </div>
  )
}

export default TransitPreviewPreviousDocuments
